export const checkDatePassed = (dateStr, timeStr) => {
  // Convert dateStr and timeStr to a JavaScript Date object
  const [day, month, year] = dateStr.split("-");
  const [hour, minute] = timeStr.split(":");
  const date = new Date(year, month - 1, day, hour, minute);

  // Get the current date and time
  const now = new Date();

  // Calculate the difference in milliseconds
  const diffMs = now - date;

  // Convert milliseconds to days
  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  // Check if the difference is more than 1 day, 5 days, or 7 days
  const oneDayPassed = diffDays > 1;
  const fiveDaysPassed = diffDays > 5;
  const sevenDaysPassed = diffDays > 7;

  return { oneDayPassed, fiveDaysPassed, sevenDaysPassed };
}
export const formatAppointments = (appointments) => {
  return appointments.map((appointment) => {
    if (appointment.IsReported) return appointment;
    const appointmentEndDate = appointment.Date;
    const appointmentEndTime = appointment.Time.split(' - ')[1];
    const { oneDayPassed, fiveDaysPassed, sevenDaysPassed } = checkDatePassed(appointmentEndDate, appointmentEndTime);

    return {
      ...appointment,
      oneDayPassed: oneDayPassed,
      fiveDaysPassed: fiveDaysPassed,
      sevenDaysPassed: sevenDaysPassed,
    };
  });
};